import type { ReferralRewardRecord } from '@navio/nsdk';

type BrandReferralSnapshot = Pick<ReferralRewardRecord, 'referralCode' | 'referrals'>;

export const resolveHasBrandDiscounts = (couponCount: number): boolean => couponCount > 0;

export const resolveHasReferralProgram = (referral: BrandReferralSnapshot): boolean => {
  const hasReferralCode = referral.referralCode != null && referral.referralCode !== '';
  const hasReferrals = referral.referrals.length > 0;
  return hasReferralCode || hasReferrals;
};
